<!--
 * @Description: 政策文件详情分享
 * @Author: lz
 * @Date: 2021-06-16 09:50:09
 * @LastEditTime: 2021-06-24 17:05:03
 * @LastEditors: lz
-->
<template>
  <div class="fileSharing">
    <!-- <div class="fileSharing_title">
     <a-icon type="close" @click="closeBrowser()" /> 
      <div class="title" v-if="info.Title && info.Title.length > 17">
        {{ info.Title.substr(0, 17) }}...
      </div>
      <div class="title" v-else>
        {{ info.Title }}
      </div>
      <div class="flex_reverse">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div> -->
    <div class="fileSharing_container">
      <div class="share" v-show="isShare && is_weixin">
        <svg-icon icon-class="share" @click="isShare = false"></svg-icon>
      </div>
      <div class="fileSharing_date">
        <!-- <div class="deadline">
          <span>报告有限期剩余：---天</span>
        </div> -->
        <h3>{{ info.Title }}</h3>
        <p>受文部门：{{ info.Dept }}</p>
        <p>发布日期：{{ info.PublishTime }}</p>
      </div>
      <div class="fileSharing_info">
        <div class="title">
          <span class="desc1"></span>
          <span class="desc2">政策详情</span>
        </div>
        <div class="declareCondition">
          <span v-html="info.Content"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { outerDetail } from "@/api/policyDocuments";
export default {
  name: "fileSharing",
  // props: {
  //   businessId: {
  //     type: String,
  //     required: true,
  //   },
  // },
  data() {
    return {
      isShare: true,
      info: {
        attachments: [],
      },
      businessId: ''
    };
  },
  created() {
    let searchObj = {};
    let search = window.location.search;
    search = search.replace("?", "");
    search = search.split("&");
    search.forEach((n) => {
      let arr = n.split("=");
      searchObj[arr[0]] = arr[1];
    });
    this.businessId = searchObj.targetId;
    this.businessId && this.pageInit();
  },
  methods: {
    async pageInit() {
      const res = await outerDetail({ id: this.businessId, isShare: 1 });
      // const res = await outerTmpDetail({ id: 168569, isShare: 1 });
      this.info = res.data.info;
    },
    closeBrowser() {
      // 判断苹果手机内置浏览器
      var ua = navigator.userAgent.toLowerCase();
      // if (window.WeixinJSBridge) {
      //   //这个可以关闭安卓系统的手机
      //   document.addEventListener(
      //     "WeixinJSBridgeReady",
      //     function () {
      //       WeixinJSBridge.call("closeWindow");
      //     },
      //     false
      //   );
      //   //这个可以关闭ios系统的手机
      //   WeixinJSBridge.call("closeWindow");
      // } else
      if (
        navigator.userAgent.indexOf("Firefox") != -1 ||
        navigator.userAgent.indexOf("Chrome") != -1
      ) {
        window.location.href = "about:blank";
        window.opener = null;
        window.open("about:blank", "_self", "").close();
      } else if (
        ua.indexOf("applewebkit") > -1 &&
        ua.indexOf("mobile") > -1 &&
        ua.indexOf("safari") > -1 &&
        ua.indexOf("linux") === -1 &&
        ua.indexOf("android") === -1 &&
        ua.indexOf("chrome") === -1 &&
        ua.indexOf("ios") === -1 &&
        ua.indexOf("browser") === -1
      ) {
        window.location.href = "about:blank";
        window.opener = null;
        window.open("about:blank", "_self", "").close();
      } else {
        window.close();
      }
    },
  },
  computed: {
    is_weixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
  },
  // watch: {
  //   $route: {
  //     immediate: true,
  //     handler(val) {
  //       if (val.query) {
  //         this.queryParam = val.query;
  //         this.pageInit();
  //       }
  //     },
  //     deep: true,
  //   },
  // },
};
</script>
<style lang="less" scoped>
@bgColor: #fff;

.fileSharing {
  .fileSharing_title {
    padding: 0.24rem 0.4rem;
    display: flex;
    align-items: center;

    .anticon-close {
      font-size: 0.28rem;
    }

    .title {
      text-align: center;
      font-size: 0.32rem;
      flex: 1;
      font-weight: 500;
      color: #3f3f40;
      line-height: 0.32rem;
      overflow: hidden;
      white-space: nowrap;
    }

    .flex_reverse {
      display: flex;
      justify-content: flex-end;
      height: 0.08rem;

      span {
        width: 0.05rem;
        height: 0.05rem;
        background: #484848;
        margin-right: 0.06rem;
        border-radius: 50%;
      }
    }
  }

  .fileSharing_container {
    background-color: @bgColor;
    padding: 0 0.4rem 0.4rem;
    max-height: calc(100vh - 0.8rem);
    overflow: hidden;
    overflow-y: scroll;
    position: relative;

    .share {
      position: fixed;
      right: 0.2rem;
      top: 0.08rem;
      width: 1.67rem;
      height: 1.07rem;

      .svg-icon {
        width: 100%;
        height: 100%;
        opacity: 0.8;
      }

      // img {
      //   width: 100%;
      //   display: block;
      // }
    }

    .fileSharing_date {
      padding: 0.24rem 0;

      // .deadline {
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      //   span {
      //     text-align: center;
      //     margin: 0.2rem 0;
      //     padding: 0.18rem 0.54rem;
      //     background: rgba(0, 114, 247, 0.7);
      //     border-radius: 0.22rem;
      //     font-size: 0.26rem;
      //     font-family: PingFangSC-Regular, PingFang SC;
      //     font-weight: 400;
      //     color: #ffffff;
      //     line-height: 0.26rem;
      //   }
      // }
      h3 {
        font-size: 0.36rem;
        font-weight: 500;
        color: #3f3f40;
        line-height: 0.44rem;
        margin-bottom: 0.3rem;
      }

      p {
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 0.26rem;
        margin-bottom: 0.24rem;
      }
    }

    .fileSharing_info {
      .title {
        margin-bottom: 0.22rem;

        .desc1 {
          display: inline-block;
          width: 0.04rem;
          height: 0.3rem;
          background: #0072f7;
        }

        .desc2 {
          margin-left: 0.18rem;
          font-size: 0.3rem;
          font-weight: 500;
          color: #3f3f40;
        }
      }

      .declareCondition {
        span {
          /deep/ * {
            font-size: 0.28rem !important;
            font-weight: 400 !important;
            color: #333333 !important;
            font-family: "PingFangSC-Medium, PingFang SC" !important;
          }
        }
      }
    }
  }
}
</style>